import { ChatUiSessionState, emptyChatUiSessionState } from '../../../../redux/features/chatUi/chatUiState';
import { RootState } from '../../../../redux/store';
import { selectChatUiBySessionId } from '../../base/chat/selectChatUiBySessionId';
import { selectSelectedSessionId } from '../../base/chat/selectSelectedSessionId';

export const selectSelectedChatUi = (state: RootState): ChatUiSessionState => {
    const sessionId = selectSelectedSessionId(state);
    if (!sessionId) {
        return emptyChatUiSessionState;
    }

    const chatUiBySessionId = selectChatUiBySessionId(state);
    return chatUiBySessionId[sessionId] ?? emptyChatUiSessionState;
};

